import React from 'react';
import { Options } from './options.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const Categories = /* @__PURE__ */ __name(({
  activeIndex,
  getItemProps,
  listRef,
  options,
  refs,
  setOpen,
  value
}) => {
  if (options.length === 0) {
    return null;
  }
  let indexOffset = 0;
  const toRender = [];
  for (const { label, options: categoryOptions } of options) {
    toRender.push(
      /* @__PURE__ */ React.createElement("div", {
        className: "mds-rebuild-input-autocomplete-menu-category",
        key: label
      }, /* @__PURE__ */ React.createElement("div", {
        className: "mds-rebuild-input-autocomplete-menu-category-title"
      }, label), /* @__PURE__ */ React.createElement(Options, {
        activeIndex,
        getItemProps,
        indexOffset,
        key: label,
        listRef,
        options: categoryOptions,
        refs,
        setOpen,
        value
      }))
    );
    indexOffset += categoryOptions.length;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, toRender);
}, "Categories");

export { Categories };
//# sourceMappingURL=categories.js.map
